/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_Annual_BonusInputs */

const en_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual bonus`)
};

const de_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jahresbonus`)
};

const fr_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prime annuelle`)
};

const es_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bono anual`)
};

const it_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonus annuale`)
};

const nl_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijkse bonus`)
};

const pl_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premia roczna`)
};

const fi_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosibonus`)
};

const da_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig bonus`)
};

const sv_salary_negotiate_other_annual_bonus = /** @type {(inputs: Salary_Negotiate_Other_Annual_BonusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årsbonus`)
};

/**
* | output |
* | --- |
* | "Annual bonus" |
*
* @param {Salary_Negotiate_Other_Annual_BonusInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_annual_bonus = /** @type {((inputs?: Salary_Negotiate_Other_Annual_BonusInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_Annual_BonusInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "es") return es_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "it") return it_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "da") return da_salary_negotiate_other_annual_bonus(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_annual_bonus(inputs)
	return en_salary_negotiate_other_annual_bonus(inputs)
});